import { twMerge } from "tailwind-merge"

// Pure display toggles: they only read/write the unit signal they are given, so they work inside
// both the product hero (HeroFormContext) and quick view (QuickShopContext), which has no HeroForm provider.

export const UnitSwitch = ({ unit, setUnit, ...props }) => {
  const handleUnitChange = () => {
    const targetUnit = unit() === 'in' ? 'cm' : 'in'
    setUnit(targetUnit)
  }

  return (<div class="cursor-pointer flex gap-1 items-center text-xs" onclick={handleUnitChange}>

    <span classList={{ 'underline': unit() === 'cm' }}>cm</span>
    <div class={twMerge(
      "border-solid border-outer border-frame p-[2px] h-4 w-6 flex",
      props.buttonClass ?? ""
    )} classList={{ 'justify-end': unit() === 'in' }}>
      <div class={
        twMerge(
          "bg-ink w-1/2",
          props.buttonContentClass ?? ""
        )
      } ></div>
    </div>
    <span classList={{ 'underline': unit() === 'in' }} >in</span>
  </div>)
}




export const InlineUnitSwitch = ({ unit, setUnit }) => {
  const handleUnitChange = () => {
    const targetUnit = unit() === 'in' ? 'cm' : 'in'
    setUnit(targetUnit)
  }
  return (
    <div
      class="cursor-pointer border-outer rounded-full ml-2 p-[2px] flex gap-1 items-center text-sm border-current"
      onclick={handleUnitChange}
    >
      <span
        class={`aspect-square text-center border-outer rounded-full w-4 h-4 flex items-center justify-center ${unit() === "cm" ? 'border-current bg-canvas-depressed' : 'border-transparent'} `}
      >
        <span class={`${unit() === "cm" ? "text-ink" : 'text-secondary-400 text-xs'}`}>cm</span>
      </span>

      <span
        class={`aspect-square text-center border-outer rounded-full w-4 h-4 flex items-center justify-center ${unit() === "in" ? 'border-current  bg-canvas-depressed' : 'border-transparent'}`}
      >
        <span class={`${unit() === "in" ? "text-ink" : 'text-secondary-400 text-xs'}`}>in</span>
      </span>
    </div>
  );
}



